import { isStarSportsPage } from '@/utils/starSportsUtils'
import { GameINFOV2, PartnerPageData, RoundStatus } from 'types/types'

export const shouldHideUIForPOTM = (game: GameINFOV2 | undefined | null) => {
  return game?.is_potm ?? false
}

export const wordingMap = {
  POTM: {
    PREDICTIONS: 'Voting',
    SAVE_PREDICTIONS: 'Save pick',
    STATS: 'Results',
    HOW_TO_PLAY: 'How to vote',
    ENTER_GAME: 'Vote now',
    TOP_PREDICTIONS: 'Results',
    TERMS_CONDITIONS: 'I have read and I accept the',
    SIGN_UP_OR_LOGIN_TO_ENTER_GAME: 'Sign up or log in to vote',
    SIGN_IN_OR_CREATE_ACCOUNT: 'Sign in or create account',
    LOG_IN_EXTERNAL_LOGIN_PROVIDER: 'Log in to vote',
    COMPLETE_ACCOUNT: 'Complete your account to start voting!',
    GAME_STARTS_IN: 'Voting finishes in',
    ROUND_STARTS_IN: 'Voting finishes in',
    GET_STARTED_LOGIN: 'Please log in to view your pick.',
    GET_STARTED_DESCRIPTION_BEFORE: 'You can edit your pick up until the voting starts',
    MAKE_YOUR_PREDICTIONS_BELOW: 'Make your pick below',
  },
  DEFAULT: {
    PREDICTIONS: 'Predictions',
    SAVE_PREDICTIONS: 'Save predictions',
    STATS: 'Stats',
    HOW_TO_PLAY: 'Game Rules',
    ENTER_GAME: 'Enter game',
    TOP_PREDICTIONS: 'Top predictions',
    TERMS_CONDITIONS: "I have read and I accept the game's",
    SIGN_UP_OR_LOGIN_TO_ENTER_GAME: 'Sign up or log in to enter game',
    LOG_IN_EXTERNAL_LOGIN_PROVIDER: 'USE YOUR STAR SPORTS ACCOUNT EMAIL ADDRESS TO LOG IN',
    SIGN_IN_OR_CREATE_ACCOUNT: 'Sign in or create account',
    COMPLETE_ACCOUNT: 'Complete your account to start playing!',
    GAME_STARTS_IN: 'Game starts in',
    ROUND_STARTS_IN: 'Round starts in',
    GET_STARTED_LOGIN: 'Please log in to view your predictions and the leaderboard.',
    GET_STARTED_DESCRIPTION_BEFORE: 'You can edit your predictions up until the tournament starts',
    MAKE_YOUR_PREDICTIONS_BELOW: 'Make your predictions below',
    CREATE_YOUR_OWN_LEAGUE_AND_COMPETE_WITH_MATES: 'CREATE YOUR OWN LEAGUE AND COMPETE WITH MATES',
    INVITE_YOUR_MATES_AND_COMPETE_TO_WIN: 'Invite your mates and compete to win!',
    CLICK_NEXT_TO_INVITE_YOUR_MATES: 'Click next to invite your mates',
    JOIN_YOUR_MATES_LEAGUE_AND_COMPETE_TO_WIN: 'Join your mates league and compete to win!',
    NOW_YOU_HAVE_JOINED_THE_GAME:
      'Now you have joined the game, why not kick off some (not so) friendly competition and create your own league to compete against your mates.',
  },
  STAR_SPORTS: {
    CREATE_YOUR_OWN_LEAGUE_AND_COMPETE_WITH_MATES:
      'CREATE YOUR OWN LEAGUE AND COMPETE WITH FRIENDS',
    INVITE_YOUR_MATES_AND_COMPETE_TO_WIN: 'Invite your friends and compete to win!',
    CLICK_NEXT_TO_INVITE_YOUR_MATES: 'Click next to invite your friends',
    JOIN_YOUR_MATES_LEAGUE_AND_COMPETE_TO_WIN: 'Join your friends league and compete to win!',
    NOW_YOU_HAVE_JOINED_THE_GAME:
      'Now you have joined the game, why not kick off some (not so) friendly competition and create your own league to compete against your friends.',
  },
} as const

export const getWording = (game: GameINFOV2 | undefined | null) => {
  if (game?.is_potm) {
    return wordingMap.POTM
  }
  return wordingMap.DEFAULT
}

export const getStartSportsWording = (page: PartnerPageData | null) => {
  if (page && isStarSportsPage(page)) {
    return wordingMap.STAR_SPORTS
  }
  return wordingMap.DEFAULT
}

export const getDefaultTab = (game: GameINFOV2 | undefined | null, isAuthenticated: boolean) => {
  const isUpcomingRounds = game?.rounds?.some((round) => round.status === RoundStatus.UPCOMING)
  const isGameStarted = game?.start_time && new Date(game.start_time) < new Date()

  if (shouldHideUIForPOTM(game)) {
    return isGameStarted ? 'stats' : 'predictions'
  }

  if (isAuthenticated) {
    return 'predictions'
  }

  return isUpcomingRounds ? 'predictions' : 'leaderboard'
}
